import { PageNotFound } from '@shared/PageNotFound/PageNotFound'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { APP_TYPE } from '@/types/User'
import { APP_STORAGE_KEY } from '@/util'
import { NotificationAlerts } from '@/views'

import PeopleFiltersContextProvider from './context/peopleFilters/peopleFilters'
import PotentialBookingFiltersContextProvider from './context/potentialBookingFilters/potentialBookingFilters'
import { WorkspaceView } from './context/workspace/workspace.type'
import { CorporateLeads, Dashboard, Peoples, PotentialBooking, PotentialBookings } from './views'
import { Agents } from './views/Agent/Agents'
import { Screenpop } from './views/Screenpop/Screenpop'
import { DefaultWorkspace } from './views/Workspace/DefaultWorkspace/DefaultWorkspace'
import { PersonSummary } from './views/Workspace/PersonSummary/PersonSummary'

export const SalesRouter = () => {
  const active_app = localStorage.getItem(APP_STORAGE_KEY)

  if (active_app !== APP_TYPE.SALES) return null

  return (
    <PotentialBookingFiltersContextProvider>
      <PeopleFiltersContextProvider>
        <Routes>
          <Route element={<Dashboard />} path="/" />
          <Route element={<Peoples />} path="/people" />
          <Route element={<Screenpop />} path="/screen-pop" />
          <Route element={<DefaultWorkspace />} path="/workspace" />
          <Route element={<Agents />} path="/agents" />
          <Route element={<CorporateLeads />} path="/corporate-leads" />
          <Route
            element={<PotentialBooking />}
            path={`/active-workspace/:bookablePersonType/:bookablePersonId/${WorkspaceView.POTENTIALBOOKING}/:potentialBookingId`}
          />
          <Route
            element={<PersonSummary />}
            path={`/active-workspace/:bookablePersonType/:bookablePersonId/${WorkspaceView.SUMMARY}`}
          />
          <Route element={<PotentialBookings />} path="/potential-booking" />
          <Route
            element={<PotentialBooking />}
            path={`/active-workspace/:bookablePersonType/:bookablePersonId/${WorkspaceView.POTENTIALBOOKING}`}
          />
          <Route
            element={<PotentialBooking />}
            path={`/active-workspace/${WorkspaceView.POTENTIALBOOKING}/:potentialBookingId`}
          />
          <Route element={<NotificationAlerts />} path="/notifications" />
          <Route element={<PageNotFound />} path="*" />
        </Routes>
      </PeopleFiltersContextProvider>
    </PotentialBookingFiltersContextProvider>
  )
}
